<template>
  <div>
    <div class="columns">
      <div class="column is-2">
        <h1 class="title">Empresas</h1>
      </div>
      <div class="column">
        <button @click="createEmpresa()" class="button is-link">
          Crear empresa
        </button>
      </div>
    </div>
    <div v-show="showform" class="notification">
      <h1 class="title is-5">Crear Empresa</h1>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">Nombre</label>
            <div class="control">
              <input
                v-model="empresa.name"
                class="input"
                type="text"
                placeholder="Nombre"
              />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">Nit</label>
            <div class="control">
              <input
                v-model="empresa.nit"
                class="input"
                type="text"
                placeholder="Nit"
              />
            </div>
          </div>
        </div>
      </div>
      <button class="button is-primary" @click="saveEmpresa()">Guardar</button>
      <button class="button is-dark" @click="cancel">Cancelar</button>
    </div>
    <div class="table">
      <thead>
        <tr>
          <th>Nombre</th>
          <th>Nit</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in empresas" :key="index">
          <td>{{ item.name }}</td>
          <td class="has-text-right fontMono">{{ item.nit | textnumber() }}</td>
          <td>
            <span @click="showEdit(item)" class="material-icons has-text-link">
              edit
            </span>
            <span
              class="material-icons has-text-danger"
              @click="delempresa(item)"
            >
              delete_forever
            </span>
          </td>
        </tr>
      </tbody>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import apiServices from "@/services/yungol-services";
export default {
  data() {
    return {
      showform: false,
      empresa: {
        _id: null,
        name: "",
        nit: "",
      },
      empresas: [],
    };
  },
  computed: {
    ...mapState(["modalnotification"]),
    resultnotification() {
      return this.modalnotification.result.aceptar;
    },
  },
  methods: {
    delempresa(inf) {
      this.$store.commit("changenotificationmodal", {
        info: {
          title: "Cuidado !",
          message: "Realmente desea eliminar la empresa?",
          clase: "is-danger",
          data: inf._id,
        },
      });
    },
    async deleteEmpresa(data) {
      try {
        const result = await apiServices.delete(
          `/deleteEmpresaProject/${data}`
        );
        if (result.data) {
          this.getEmpresas();
        }
      } catch (err) {
        console.log(err);
      }
    },
    showEdit(empresa) {
      this.empresa = JSON.parse(JSON.stringify(empresa));
      this.showform = true;
    },
    async getEmpresas() {
      try {
        const result = await apiServices.get(`/getEmpresaProject`);
        if (result.data) {
          this.empresas = result.data;
        }
      } catch (err) {
        console.log(err);
      }
    },
    async saveEmpresa() {
      try {
        if (!this.empresa.name) {
          this.$store.dispatch("notify", {
            message: "Debe ingresar el nombre",
            type: "is-warning",
            position: "top-center",
          });
          return;
        }
        let result;
        if (this.empresa._id) {
          result = await apiServices.put(`/editEmpresaProject`, this.empresa);
        } else {
          result = await apiServices.post(`/saveEmpresaProject`, this.empresa);
        }
        if (result.data) {
          this.getEmpresas();
          this.showform = false;
        }
      } catch (err) {
        console.log(err);
      }
    },
    createEmpresa() {
      this.empresa = {
        _id: null,
        name: "",
        nit: "",
      };
      this.showform = true;
    },
    cancel() {
      this.showform = false;
    },
  },
  watch: {
    resultnotification(nv, ov) {
      if (nv) {
        this.deleteEmpresa(this.modalnotification.result.data);
      }
    },
  },
  created() {
    this.getEmpresas();
  },
};
</script>


// WEBPACK FOOTER //
// src/components/proyectos/configuracion/Empresas.vue